import { useTranslation } from 'next-i18next';
import { useContext, useId, useState, VFC } from 'react';

import styles from '@/containers/MarketplacePage/FilterSideBar/FilterSideBar.module.scss';
import { MarketplaceCreationStatus } from '@/containers/MarketplacePage/interface';
import MarketplaceItemsContext from '@/contexts/MarketplaceItemsContext';
import ChevronRight2 from '@/icons/chevron-right2.svg';

const Availability: VFC = () => {
  const { t } = useTranslation();
  const id = useId();
  const [isCollapsed, setIsCollapsed] = useState(false);

  const { searchConditionNFTs, setSearchConditionNFTs } = useContext(
    MarketplaceItemsContext
  );

  const handleStatusChange = (newStatus: MarketplaceCreationStatus): void => {
    const newSearchConditionNFTs = {
      ...searchConditionNFTs,
      status: newStatus,
    };
    setSearchConditionNFTs(newSearchConditionNFTs);
  };

  const statuses: {
    [key in MarketplaceCreationStatus]: string;
  } = {
    all: t('filterSidebar.availability.options.all'),
    available: t('filterSidebar.availability.options.available'),
    sold: t('filterSidebar.availability.options.sold'),
    reserved: t('filterSidebar.availability.options.reserved'),
    auction: t('filterSidebar.availability.options.auction'),
  };

  return (
    <div className={styles.sidebarSubsection}>
      <div className={styles.title}>
        {t('filterSidebar.availability.heading')}
      </div>
      <ChevronRight2
        className={
          isCollapsed ? styles.collapseButtonClicked : styles.collapseButton
        }
        onClick={() => {
          setIsCollapsed(!isCollapsed);
        }}
      />
      {!isCollapsed && (
        <div className={styles.availabilityRadios}>
          {Object.entries(statuses).map(([key, value]) => (
            <div key={key} className="radio">
              <input
                id={`${id}_radio_${key}`}
                type="radio"
                value={key}
                checked={searchConditionNFTs.status === key}
                onChange={(e) =>
                  handleStatusChange(
                    e.target.value as MarketplaceCreationStatus
                  )
                }
              />
              <label htmlFor={`${id}_radio_${key}`} className="radio-label">
                {value}
              </label>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Availability;
